import getConfig from 'next/config';

const { apiPrefix = '' } = getConfig()?.publicRuntimeConfig ?? {};

export const BFF_API_ROUTES = {
  getVitrinsOffers: '/get-vitrins-offers/',
  account: '/account/',
  getScores: '/get-scores/',
  getRegionalCenters: '/get-regional-centers/',

  getLoanChartFilters: '/chart-filters/',
  getLoansData: '/loans-data/',

  getIfUserHasEsia: '/has-esia/',

  getOffersAndGroups: '/offers-and-groups/',
  applyOffer: '/apply-offer/',
  getStatuses: '/statuses/',
  getStatusesV2: '/statuses-v2/',

  getAutoModels: '/get-auto-models/',
  getAutoBrands: '/get-auto-brands/',

  validatePassport: '/validate-passport/',

  getFullAddressesAutocomplete: '/get-full-addresses-autocomplete/',
  getSeparateAddressesAutocomplete: '/get-separate-addresses-autocomplete/',
  getFullNameSuggest: '/get-full-name-suggest/',
  getOrganizationSuggestions: '/get-organization-suggestions/',
  getUnitCodeSuggestions: '/get-unit-code-suggestions/',
  getIssuedBySuggestions: '/get-issued-by-suggestions/',
  getLocationSettlement: '/get-location-settlement/',
  getLocationByFiasId: '/get-location-by-fias-id/',
  updateUserData: '/update-user-data/',
  getUserData: '/get-user-data/',

  sendContact: '/send-contact/',
  sendCalculation: '/send-calculation/',
  sendReferralApplication: '/send-referral-application/',
  sendPreApprovalsSearchApplication: '/send-pre-approvals-search-application/',
  sendApplicationV2: '/send-application-v2/',
  sendFirstTouch: '/send-first-touch/',

  getCarEnginePowers: '/get-car-engine-powers/',
  getCarManufactureYears: '/get-car-manufacture-years/',
  getCarModifications: '/get-car-modifications/',
  getCarInfo: '/get-car-info/',
  restoreUserData: '/restore-user-data/',
  restoreWhiteLabelUserData: '/restore-white-label-user-data/',
  getBranches: '/get-branches/',

  start: '/flow/start/',
  next: '/flow/next/',
  step: '/flow/step/',
  offerDisbursementStep: '/flow/offer-disbursement-step/',

  sendMonitoringEvent: '/send-monitoring-event/',

  getUTMCookies: '/get-utm-cookies/',
  initMfoDeal: '/init-mfo-deal/',
  getJobPositionSuggest: '/get-job-position-suggest/',
  getDeliverySlots: '/delivery/slots/',
  getIframeInfo: '/iframe/info',
  updateDeliveryAddress: '/delivery/address/update/',
  selectDeliverySlot: '/delivery/slot/select/',
  confirmationRequestDelivery: '/delivery/confirmation/request/',
  confirmationSubmitDelivery: '/delivery/confirmation/submit/',
  getProduct: '/feeds/product/',
  getSelectionProduct: '/selection/web/product/',
  stTrackingClick: '/st-tracking/click/',
  stTrackingPostback: '/st-tracking/postback/',
  getFeed: '/feed.xml',
  downloadDocument: '/download-document/',
  getEssentialCreditStatus: '/essential-credit-status/',
};

export const BFF_PROXY_API: Record<keyof typeof BFF_API_ROUTES, string> = {
  getScores: `${apiPrefix}${BFF_API_ROUTES.getScores}`,
  account: `${apiPrefix}${BFF_API_ROUTES.account}`,
  getRegionalCenters: `${apiPrefix}${BFF_API_ROUTES.getRegionalCenters}`,
  sendMonitoringEvent: `${apiPrefix}${BFF_API_ROUTES.sendMonitoringEvent}`,
  getLoanChartFilters: `${apiPrefix}${BFF_API_ROUTES.getLoanChartFilters}`,
  getLoansData: `${apiPrefix}${BFF_API_ROUTES.getLoansData}`,
  getIfUserHasEsia: `${apiPrefix}${BFF_API_ROUTES.getIfUserHasEsia}`,
  getOffersAndGroups: `${apiPrefix}${BFF_API_ROUTES.getOffersAndGroups}`,
  applyOffer: `${apiPrefix}${BFF_API_ROUTES.applyOffer}`,
  getAutoModels: `${apiPrefix}${BFF_API_ROUTES.getAutoModels}`,
  getAutoBrands: `${apiPrefix}${BFF_API_ROUTES.getAutoBrands}`,
  getFullAddressesAutocomplete: `${apiPrefix}${BFF_API_ROUTES.getFullAddressesAutocomplete}`,
  getSeparateAddressesAutocomplete: `${apiPrefix}${BFF_API_ROUTES.getSeparateAddressesAutocomplete}`,
  getFullNameSuggest: `${apiPrefix}${BFF_API_ROUTES.getFullNameSuggest}`,
  getOrganizationSuggestions: `${apiPrefix}${BFF_API_ROUTES.getOrganizationSuggestions}`,
  getUnitCodeSuggestions: `${apiPrefix}${BFF_API_ROUTES.getUnitCodeSuggestions}`,
  getIssuedBySuggestions: `${apiPrefix}${BFF_API_ROUTES.getIssuedBySuggestions}`,
  validatePassport: `${apiPrefix}${BFF_API_ROUTES.validatePassport}`,
  getLocationSettlement: `${apiPrefix}${BFF_API_ROUTES.getLocationSettlement}`,
  getLocationByFiasId: `${apiPrefix}${BFF_API_ROUTES.getLocationByFiasId}`,
  updateUserData: `${apiPrefix}${BFF_API_ROUTES.updateUserData}`,
  getUserData: `${apiPrefix}${BFF_API_ROUTES.getUserData}`,
  sendContact: `${apiPrefix}${BFF_API_ROUTES.sendContact}`,
  sendCalculation: `${apiPrefix}${BFF_API_ROUTES.sendCalculation}`,
  sendReferralApplication: `${apiPrefix}${BFF_API_ROUTES.sendReferralApplication}`,
  sendApplicationV2: `${apiPrefix}${BFF_API_ROUTES.sendApplicationV2}`,
  sendFirstTouch: `${apiPrefix}${BFF_API_ROUTES.sendFirstTouch}`,
  sendPreApprovalsSearchApplication: `${apiPrefix}${BFF_API_ROUTES.sendPreApprovalsSearchApplication}`,
  getCarEnginePowers: `${apiPrefix}${BFF_API_ROUTES.getCarEnginePowers}`,
  getCarManufactureYears: `${apiPrefix}${BFF_API_ROUTES.getCarManufactureYears}`,
  getCarModifications: `${apiPrefix}${BFF_API_ROUTES.getCarModifications}`,
  getCarInfo: `${apiPrefix}${BFF_API_ROUTES.getCarInfo}`,
  restoreUserData: `${apiPrefix}${BFF_API_ROUTES.restoreUserData}`,
  restoreWhiteLabelUserData: `${apiPrefix}${BFF_API_ROUTES.restoreWhiteLabelUserData}`,
  getBranches: `${apiPrefix}${BFF_API_ROUTES.getBranches}`,
  start: `${apiPrefix}${BFF_API_ROUTES.start}`,
  getStatuses: `${apiPrefix}${BFF_API_ROUTES.getStatuses}`,
  getStatusesV2: `${apiPrefix}${BFF_API_ROUTES.getStatusesV2}`,
  getVitrinsOffers: `${apiPrefix}${BFF_API_ROUTES.getVitrinsOffers}`,
  getUTMCookies: `${apiPrefix}${BFF_API_ROUTES.getUTMCookies}`,
  next: `${apiPrefix}${BFF_API_ROUTES.next}`,
  step: `${apiPrefix}${BFF_API_ROUTES.step}`,
  offerDisbursementStep: `${apiPrefix}${BFF_API_ROUTES.offerDisbursementStep}`,
  initMfoDeal: `${apiPrefix}${BFF_API_ROUTES.initMfoDeal}`,
  getJobPositionSuggest: `${apiPrefix}${BFF_API_ROUTES.getJobPositionSuggest}`,
  getDeliverySlots: `${apiPrefix}${BFF_API_ROUTES.getDeliverySlots}`,
  getIframeInfo: `${apiPrefix}${BFF_API_ROUTES.getIframeInfo}`,
  updateDeliveryAddress: `${apiPrefix}${BFF_API_ROUTES.updateDeliveryAddress}`,
  selectDeliverySlot: `${apiPrefix}${BFF_API_ROUTES.selectDeliverySlot}`,
  confirmationRequestDelivery: `${apiPrefix}${BFF_API_ROUTES.confirmationRequestDelivery}`,
  confirmationSubmitDelivery: `${apiPrefix}${BFF_API_ROUTES.confirmationSubmitDelivery}`,
  getProduct: `${apiPrefix}${BFF_API_ROUTES.getProduct}`,
  getSelectionProduct: `${apiPrefix}${BFF_API_ROUTES.getSelectionProduct}`,
  stTrackingClick: `${apiPrefix}${BFF_API_ROUTES.stTrackingClick}`,
  stTrackingPostback: `${apiPrefix}${BFF_API_ROUTES.stTrackingPostback}`,
  getFeed: `${apiPrefix}${BFF_API_ROUTES.getFeed}`,
  downloadDocument: `${apiPrefix}${BFF_API_ROUTES.downloadDocument}`,
  getEssentialCreditStatus: `${apiPrefix}${BFF_API_ROUTES.getEssentialCreditStatus}`,
};
